import * as $ from 'jquery';
import * as ko from 'knockout';
import {PikadayService} from "../services/pikadayService";

declare var DobryKantor: any;
declare var CANTORVERSION: any;
declare var BACKENDPATH: any;

export class NbpCurrencyRateComponent {
    currency: ko.Observable<string>;
    date: ko.Observable<string>;
    rate: ko.Observable<number>;

    constructor(params) {
        this.currency = ko.observable(params.currency);
        this.date = ko.observable(new Date().toISOString().slice(0, 10));
        this.rate = ko.observable(null);

        this.date.subscribe(newValue => {
            this.getCurrencyRate()
        });

        this.getCurrencyRate();

        let pikadayService = new PikadayService();

        pikadayService.init($('#nbp-currency-rate-date')[0] as HTMLElement);
    }

    getCurrencyRate() {
        return $.getJSON(BACKENDPATH + '/api/currency/nbp-currency-rate', {
            currency: this.currency(),
            date: this.date()
        }).then((result) => {
            this.rate(result.mid);
        });
    }


}
